export default __webpack_public_path__ + "static/technical-7a72d459542b0a215f36c5ea3d130148.png";